// todo: fetch from backend
export const PermissionName: Record<number, string> = {
  [100]: "ManageLocations",
  [101]: "ManageUsers",
  [102]: "ViewCampaigns",
  [103]: "ViewContent",
  [104]: "ViewFeedback",
  [105]: "ViewLocations",
  [106]: "ViewReports",
  [107]: "ViewSettingsUsers",
  [200]: "UserManagement",
  [201]: "SendScheduleCampaigns",
  [202]: "ChangeAutomaticCampaignSettings",
  [203]: "ViewReviews",
  [204]: "FeatureReviewsRespond",
  [205]: "ViewSurveys",
  [206]: "SeeProcessPayments",
  [207]: "ChangePracticeSettings",
  [208]: "Billing",
  [209]: "Forms",
  [210]: "ManageCampaigns",
  [400]: "AdminGeneralAccess",
  [401]: "ContentView",
  [402]: "ContentManagement",
  [403]: "Reporting",
  [404]: "RemoteLocationLogin",
  [405]: "Alerts",
  [406]: "IfByPhoneAudioManager",
  [407]: "ReputationMonitor",
  [408]: "SocialMediaManager",
  [409]: "Demo",
  [410]: "LocationTools",
  [411]: "ViewLocations",
  [412]: "SystemConfigurationManagement",
  [413]: "BackgroundJobsManagement",
  [414]: "DataSyncManagement",
  [415]: "EditDemoPrototypePractice",
  [416]: "ManageDemoEnvironment",
  [417]: "BillingReport",
  [418]: "Statements",
  [419]: "CopyPatientsPreferencesAndReviews",
  [420]: "RemovePatientIdentity",
  [421]: "ResetPhoneNumber",
  [422]: "RemoteCustomerUserLogin",
  [500]: "PattersonCreatePdCustomerPermission",
  [501]: "PattersonCustomersPermission",
  [502]: "PattersonDemoPermission",
  [503]: "PattersonDocumentsPermission",
  [504]: "PattersonImagesPermission",
  [505]: "PattersonKnowledgeBasePermission",
  [506]: "PattersonReportsPermission",
  [507]: "PattersonTrainingPermission",
  [600]: "ManageContent",
  [601]: "ManageCustomers",
  [602]: "ManageDatasyncConfiguration",
  [603]: "ProvisionAccounts",
  [604]: "CustomerTools",
  [605]: "UpdateFeatureFlags",
  [606]: "AdvancedFeatureFlagManagement",
  [700]: "VirtualPrinter",
  [800]: "CoreApi",
  [801]: "FormsApi",
  [802]: "MessengerApi",
  [900]: "ManageVirtualOffices",
  [901]: "ManageEnterpriseTextCommunicationSettings",
  [902]: "ManagePracticeTextCommunicationSettings",
  [1000]: "CreateForm",
  [1001]: "DeleteForm",
  [1003]: "EditContentForm",
  [1004]: "ManageFormPacket"
};